module.exports = __webpack_public_path__ + "static/media/UNIEUR.fc969c85.svg";